/** Panasonic様作成のコンテンツについての情報 */
export const WEB_CONTENT_CONST = {
  /** フォルダー */
  WEB_CONTENT_ROOT_FOLDER: "/KadenContents_lp/Refrigerator/"
};
  